import ExploreMixin from '@/mixins/ExploreMixin'
import { TimelineMax } from 'gsap'

export default {
  name: 'ChampSelect',
  template: '#champ-select-template',
  mixins: [ExploreMixin],
  data () {
    return {
      progress: 0,
      tl: new TimelineMax({paused: true}),
      messageNum: 0,
      gold: false,
      progs: [
        {
          active: false
        },
        {
          active: false
        },
        {
          active: false
        },
        {
          active: false
        }
      ]
    }
  },
  computed: {
    svgChildren () {
      return [...this.$refs.champSelectSvg.children]
    }
  },
  methods: {
    changeCurrentMessage (x) {
      this.messageNum = x
    },
    goldTrue () {
      this.gold = true
    },
    goldFalse () {
      this.gold = false
    },
    playChamp (x) {
      this.progs.forEach((x) => {
        x.active = false
      })
      this.progs[x - 1].active = true

      if (x === 1) {
        this.gold = false
        this.tl.tweenTo('start').duration(0)
        this.tl.tweenTo('round1')
        this.trackEvent('Pick Your Champs', 'Pick Your Champs: Button: Ban Phase 1')
      } else if (x === 2) {
        this.gold = true
        this.tl.tweenTo('round1').duration(0)
        this.tl.tweenTo('round2')
        this.trackEvent('Pick Your Champs', 'Pick Your Champs: Button: Pick Phase 1')
      } else if (x === 3) {
        this.gold = false
        this.tl.tweenTo('round2').duration(0)
        this.tl.tweenTo('round3')
        this.trackEvent('Pick Your Champs', 'Pick Your Champs: Button: Ban Phase 2')
      } else if (x === 4) {
        this.gold = true
        this.tl.tweenTo('round3').duration(0)
        this.tl.tweenTo('round4')
        this.trackEvent('Pick Your Champs', 'Pick Your Champs: Button: Pick Phase 2')
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      // Rd 1

      // fade in bans
      this.tl.add('start')
      this.tl.to(this.$refs.banz, 0.6, {opacity: 1, onStart: this.changeCurrentMessage, onStartParams: [1], onReverseComplete: this.changeCurrentMessage, onReverseCompleteParams: [0]})
      // red gradient fade 1
      this.tl.to(this.$refs.bkg1, 0.6, {opacity: 1}, '-=1')
      // ban 1
      this.tl.to(this.$refs.ban1.getElementsByTagName('rect')[1], 0.6, {fill: 'rgba(0, 0, 0, 0)'})
      this.tl.to(this.$refs.banicon1, 0.6, {opacity: 1}, '-=0.6')
      // ban 2
      this.tl.to(this.$refs.bkg1, 0.6, {opacity: 0})
      this.tl.to(this.$refs.bkg2, 0.6, {opacity: 1}, '-=0.6')
      this.tl.to(this.$refs.ban2.getElementsByTagName('rect')[1], 0.6, {fill: 'rgba(0, 0, 0, 0)'})
      this.tl.to(this.$refs.ban2s, 0.6, {opacity: 1}, '-=0.6')
      // ban 3
      this.tl.to(this.$refs.bkg2, 0.6, {opacity: 0})
      this.tl.to(this.$refs.bkg1, 0.6, {opacity: 1}, '-=0.6')
      this.tl.to(this.$refs.ban3.getElementsByTagName('rect')[1], 0.6, {fill: 'rgba(0, 0, 0, 0)'})
      this.tl.to(this.$refs.banicon3, 0.6, {opacity: 1}, '-=0.6')
      // ban 4
      this.tl.to(this.$refs.bkg1, 0.6, {opacity: 0})
      this.tl.to(this.$refs.bkg2, 0.6, {opacity: 1}, '-=0.6')
      this.tl.to(this.$refs.ban4.getElementsByTagName('rect')[1], 0.6, {fill: 'rgba(0, 0, 0, 0)'})
      this.tl.to(this.$refs.ban4s, 0.6, {opacity: 1}, '-=0.6')
      // ban 5
      this.tl.to(this.$refs.bkg2, 0.6, {opacity: 0})
      this.tl.to(this.$refs.bkg1, 0.6, {opacity: 1}, '-=0.6')
      this.tl.to(this.$refs.ban5.getElementsByTagName('rect')[1], 0.6, {fill: 'rgba(0, 0, 0, 0)'})
      this.tl.to(this.$refs.banicon5, 0.6, {opacity: 1}, '-=0.6')
      // ban 6
      this.tl.to(this.$refs.bkg1, 0.6, {opacity: 0})
      this.tl.to(this.$refs.bkg2, 0.6, {opacity: 1}, '-=0.6')
      this.tl.to(this.$refs.ban6.getElementsByTagName('rect')[1], 0.6, {fill: 'rgba(0, 0, 0, 0)'})
      this.tl.to(this.$refs.banicon6, 0.6, {opacity: 1}, '-=0.6')
      this.tl.to(this.$refs.bkg2, 0.6, {opacity: 0, onComplete: this.goldTrue, onReverseComplete: this.goldFalse})
      this.tl.add('round1')

      // Rd 2

      // snake 1
      this.tl.to(this.$refs.bkg1, 0.6, {opacity: 1, onStart: this.changeCurrentMessage, onStartParams: [2], onReverseComplete: this.changeCurrentMessage, onReverseCompleteParams: [1]})
      this.tl.to([this.$refs.snake1, this.$refs.en1], 0.6, {opacity: 1})
      // snake 2
      this.tl.to(this.$refs.bkg1, 0.6, {opacity: 0})
      this.tl.to(this.$refs.bkg2, 0.6, {opacity: 1}, '-=0.6')
      this.tl.to(this.$refs.bkg3, 0.6, {opacity: 1}, '-=0.6')
      this.tl.to([this.$refs.snake2, this.$refs.en6], 0.6, {opacity: 1})
      // snake 3
      this.tl.to([this.$refs.snake3, this.$refs.en7], 0.6, {opacity: 1})
      // snake 4
      this.tl.to(this.$refs.bkg2, 0.6, {opacity: 0})
      this.tl.to(this.$refs.bkg3, 0.6, {opacity: 0}, '-=0.6')
      this.tl.to(this.$refs.bkg4, 0.6, {opacity: 1}, '-=0.6')
      this.tl.to(this.$refs.bkg5, 0.6, {opacity: 1}, '-=0.6')
      this.tl.to([this.$refs.snake4, this.$refs.en2], 0.6, {opacity: 1})
      // snake 5
      this.tl.to([this.$refs.snake5, this.$refs.en3], 0.6, {opacity: 1})
      // snake 6
      this.tl.to(this.$refs.bkg4, 0.6, {opacity: 0})
      this.tl.to(this.$refs.bkg5, 0.6, {opacity: 0}, '-=0.6')
      this.tl.to(this.$refs.bkg6, 0.6, {opacity: 1}, '-=0.6')
      this.tl.to([this.$refs.snake6, this.$refs.en8], 0.6, {opacity: 1})
      this.tl.add('round2')

      // Rd 3

      this.tl.to(this.$refs.bkg6, 0.6, {opacity: 0, onComplete: this.goldFalse, onStart: this.changeCurrentMessage, onStartParams: [3], onReverseComplete: this.changeCurrentMessage, onReverseCompleteParams: [2]})
      // ban 7
      this.tl.to(this.$refs.bkg2, 0.6, {opacity: 1}, '-=0.6')
      this.tl.to(this.$refs.ban7.getElementsByTagName('rect')[1], 0.6, {fill: 'rgba(0, 0, 0, 0)'})
      this.tl.to(this.$refs.banicon7, 0.6, {opacity: 1}, '-=0.6')
      // ban 8
      this.tl.to(this.$refs.bkg2, 0.6, {opacity: 0})
      this.tl.to(this.$refs.bkg1, 0.6, {opacity: 1}, '-=0.6')
      this.tl.to(this.$refs.ban8.getElementsByTagName('rect')[1], 0.6, {fill: 'rgba(0, 0, 0, 0)'})
      this.tl.to(this.$refs.banicon8, 0.6, {opacity: 1}, '-=0.6')
      // ban 9
      this.tl.to(this.$refs.bkg1, 0.6, {opacity: 0})
      this.tl.to(this.$refs.bkg2, 0.6, {opacity: 1}, '-=0.6')
      this.tl.to(this.$refs.ban9.getElementsByTagName('rect')[1], 0.6, {fill: 'rgba(0, 0, 0, 0)'})
      this.tl.to(this.$refs.banicon9, 0.6, {opacity: 1}, '-=0.6')
      // ban 10
      this.tl.to(this.$refs.bkg2, 0.6, {opacity: 0})
      this.tl.to(this.$refs.bkg1, 0.6, {opacity: 1}, '-=0.6')
      this.tl.to(this.$refs.ban10.getElementsByTagName('rect')[1], 0.6, {fill: 'rgba(0, 0, 0, 0)'})
      this.tl.to(this.$refs.banicon10, 0.6, {opacity: 1}, '-=0.6')
      this.tl.add('round3')

      // Rd 4

      this.tl.to(this.$refs.bkg1, 0.6, {opacity: 0, onComplete: this.goldTrue, onStart: this.changeCurrentMessage, onStartParams: [4], onReverseComplete: this.changeCurrentMessage, onReverseCompleteParams: [3]})
      // snake 7
      this.tl.to(this.$refs.bkg7, 0.6, {opacity: 1, onReverseComplete: this.goldFalse})
      this.tl.to([this.$refs.snake7, this.$refs.en9], 0.6, {opacity: 1})
      // snake 8
      this.tl.to(this.$refs.bkg7, 0.6, {opacity: 0})
      this.tl.to(this.$refs.bkg8, 0.6, {opacity: 1}, '-=0.6')
      this.tl.to(this.$refs.bkg9, 0.6, {opacity: 1}, '-=0.6')
      this.tl.to([this.$refs.snake8, this.$refs.en4], 0.6, {opacity: 1})
      // snake 9
      this.tl.to([this.$refs.snake9, this.$refs.en5], 0.6, {opacity: 1})
      // snake 10
      this.tl.to(this.$refs.bkg8, 0.6, {opacity: 0})
      this.tl.to(this.$refs.bkg9, 0.6, {opacity: 0}, '-=0.6')
      this.tl.to(this.$refs.bkg10, 0.6, {opacity: 1}, '-=0.6')
      this.tl.to([this.$refs.snake10, this.$refs.en10], 0.6, {opacity: 1, onComplete: this.changeCurrentMessage, onCompleteParams: [4], onReverseComplete: this.changeCurrentMessage, onReverseCompleteParams: [4]})
      this.tl.add('round4')
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/compete/ChampSelect.js